/* Buckle & Brooks — interactions. No dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header height → CSS var (hero fits the first screen) ---------- */
  function setHeaderH() {
    var h = document.querySelector('.section-header');
    var a = document.querySelector('.announcement-bar-section');
    var total = (h ? h.offsetHeight : 0) + (a ? a.offsetHeight : 0);
    document.documentElement.style.setProperty('--bb-header-h', total + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH, { passive: true });

  /* ---------- Split headlines into words ---------- */
  function split(el) {
    if (el.dataset.bbSplitDone) return;
    el.dataset.bbSplitDone = '1';
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'bb-w';
            var inner = document.createElement('span');
            inner.style.setProperty('--i', i++);
            inner.textContent = p;
            w.appendChild(inner);
            frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    })(el);
  }

  /* ---------- Reveal on scroll ---------- */
  var io = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  function initReveal(root) {
    (root || document).querySelectorAll('[data-bb-split]').forEach(function (el) {
      split(el);
      el.classList.add('bb-split');
    });
    (root || document).querySelectorAll('[data-bb-reveal], .bb-split, .bb-value, .bb-timeline__step').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- Count up (only for real numbers set in the editor) ---------- */
  function initCount(root) {
    (root || document).querySelectorAll('[data-bb-count]').forEach(function (el) {
      var end = parseFloat(el.getAttribute('data-bb-count'));
      if (isNaN(end) || reduce) { el.textContent = el.getAttribute('data-bb-count'); return; }
      var dec = (String(end).split('.')[1] || '').length;
      var run = function () {
        var t0 = performance.now(), dur = 1400;
        (function tick(t) {
          var p = Math.min(1, (t - t0) / dur);
          var v = end * (1 - Math.pow(1 - p, 3));
          el.textContent = v.toFixed(dec);
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      };
      if (!('IntersectionObserver' in window)) return run();
      var o = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { run(); o.disconnect(); }
      }, { threshold: 0.5 });
      o.observe(el);
    });
  }

  /* ---------- Tabs (Available / Upcoming) ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-bb-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('[role="tab"]');
      var thumb = wrap.querySelector('.bb-tabs__thumb');
      function place(btn) {
        if (!thumb || !btn) return;
        thumb.style.width = btn.offsetWidth + 'px';
        thumb.style.transform = 'translateX(' + (btn.offsetLeft - 4) + 'px)';
      }
      function select(btn) {
        btns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = wrap.querySelector('#' + b.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });
        place(btn);
      }
      btns.forEach(function (b, idx) {
        b.addEventListener('click', function () { select(b); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = btns[(idx + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length];
          n.focus(); select(n);
        });
      });
      var current = wrap.querySelector('[role="tab"][aria-selected="true"]') || btns[0];
      requestAnimationFrame(function () { place(current); });
      window.addEventListener('resize', function () {
        place(wrap.querySelector('[role="tab"][aria-selected="true"]'));
      }, { passive: true });
    });
  }

  /* ---------- Material compare switch ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-bb-compare]').forEach(function (wrap) {
      var sw = wrap.querySelector('.bb-switch');
      var btns = wrap.querySelectorAll('.bb-switch__btn');
      var panels = wrap.querySelectorAll('.bb-compare__panel');
      var imgs = wrap.querySelectorAll('.bb-compare__visual img');
      var label = wrap.querySelector('.bb-compare__visual-label');
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.classList.toggle('is-active', i === j); });
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
          if (sw) sw.setAttribute('data-active', i);
          if (label) label.textContent = b.getAttribute('data-label') || b.textContent;
        });
      });
    });
  }

  /* ---------- Horizontal rail progress ---------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-bb-rail]').forEach(function (rail) {
      var bar = document.querySelector('[data-bb-progress="' + rail.id + '"] span');
      if (!bar) return;
      var upd = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var vis = rail.clientWidth / rail.scrollWidth;
        var p = max > 0 ? vis + (1 - vis) * (rail.scrollLeft / max) : 1;
        bar.style.setProperty('--p', p.toFixed(3));
      };
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd, { passive: true });
      upd();
    });
  }

  /* ---------- Timeline fill follows scroll ---------- */
  function initTimelines(root) {
    var lines = (root || document).querySelectorAll('[data-bb-timeline]');
    if (!lines.length) return;
    var ticking = false;
    function upd() {
      lines.forEach(function (tl) {
        var r = tl.getBoundingClientRect();
        var vh = window.innerHeight;
        var horizontal = getComputedStyle(tl).display === 'grid' && window.innerWidth >= 990;
        var p;
        if (horizontal) {
          p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (vh * 0.5)));
        } else {
          p = Math.min(1, Math.max(0, (vh * 0.7 - r.top) / r.height));
        }
        tl.style.setProperty('--p', reduce ? 1 : p.toFixed(3));
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(upd); ticking = true; }
    }, { passive: true });
    upd();
  }

  /* ---------- Real countdown (to a fixed date from a metafield; never resets) ---------- */
  function initClocks(root) {
    (root || document).querySelectorAll('[data-bb-until]').forEach(function (el) {
      var raw = el.getAttribute('data-bb-until') || '';
      var end = /^\d+$/.test(raw) ? parseInt(raw, 10) : Date.parse(raw);
      if (isNaN(end)) { el.hidden = true; return; }
      var f = {
        d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'),
        m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]')
      };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      (function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          var done = el.getAttribute('data-bb-done');
          if (done) el.outerHTML = '<p class="bb-preorder__stock-txt">' + done + '</p>';
          else el.hidden = true;
          return;
        }
        var s = Math.floor(left / 1000);
        if (f.d) f.d.textContent = pad(Math.floor(s / 86400));
        if (f.h) f.h.textContent = pad(Math.floor((s % 86400) / 3600));
        if (f.m) f.m.textContent = pad(Math.floor((s % 3600) / 60));
        if (f.s) f.s.textContent = pad(s % 60);
        setTimeout(tick, 1000);
      })();
    });
  }

  /* ---------- Stock bars (real inventory) ---------- */
  function initBars(root) {
    (root || document).querySelectorAll('[data-bb-bar]').forEach(function (bar) {
      var v = Math.max(0, Math.min(1, parseFloat(bar.getAttribute('data-bb-bar')) || 0));
      bar.style.transform = 'scaleX(0)';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { bar.style.transform = 'scaleX(' + v + ')'; });
      });
    });
  }

  /* ---------- Sticky add to cart: mirrors and clicks the real Dawn button ---------- */
  function initSticky() {
    var sticky = document.querySelector('[data-bb-sticky]');
    if (!sticky) return;
    var form = document.querySelector('product-form form[action*="/cart/add"], form[id^="product-form-"]');
    var realBtn = form && form.querySelector('[type="submit"]');
    var btn = sticky.querySelector('[data-bb-sticky-btn]');
    var priceEl = sticky.querySelector('[data-bb-sticky-price]');
    if (!realBtn || !btn) { sticky.remove(); return; }

    function sync() {
      var label = realBtn.querySelector('span');
      btn.querySelector('span').textContent = (label ? label.textContent : realBtn.textContent).trim();
      btn.disabled = realBtn.disabled;
      var p = document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');
      if (priceEl && p) priceEl.textContent = p.textContent.trim();
    }
    btn.addEventListener('click', function () {
      if (realBtn.disabled) {
        realBtn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      realBtn.click();
    });
    new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true });
    sync();

    // Scroll-based (not IntersectionObserver) so fast flicks and jumps are caught too
    var ticking = false;
    function check() {
      ticking = false;
      var show = realBtn.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-on', show);
      document.body.classList.toggle('bb-has-sticky', show);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  /* ---------- Intro curtain (once per visit) ---------- */
  function initIntro() {
    var intro = document.querySelector('[data-bb-intro]');
    if (!intro) return;
    var seen = false;
    try { seen = sessionStorage.getItem('bb_intro') === '1'; } catch (e) {}
    if (seen || reduce || window.Shopify && Shopify.designMode) { intro.remove(); return; }
    document.documentElement.classList.add('bb-intro-lock');
    var close = function () {
      if (intro.classList.contains('is-open')) return;
      intro.classList.add('is-open');
      document.documentElement.classList.remove('bb-intro-lock');
      try { sessionStorage.setItem('bb_intro', '1'); } catch (e) {}
      setTimeout(function () { intro.classList.add('is-done'); intro.remove(); }, 1200);
    };
    intro.style.pointerEvents = 'auto';
    intro.addEventListener('click', close);
    setTimeout(close, parseInt(intro.getAttribute('data-duration') || '1900', 10));
  }

  /* ---------- Smooth open/close for FAQ details ---------- */
  function initFaq(root) {
    if (reduce) return;
    (root || document).querySelectorAll('.bb-faq__item').forEach(function (d) {
      var s = d.querySelector('summary');
      var body = d.querySelector('.bb-faq__body');
      if (!s || !body || d.dataset.bbFaq) return;
      d.dataset.bbFaq = '1';
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h = body.offsetHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.65,0,.35,1)' })
            .onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.16,1,.3,1)' });
        }
      });
    });
  }

  /* ---------- Hero video: pause when off screen, save data ---------- */
  function initVideos() {
    document.querySelectorAll('video[data-bb-autoplay]').forEach(function (v) {
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
      var conn = navigator.connection;
      if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) { v.pause(); return; }
      var o = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
      o.observe(v);
    });
  }

  function initAll(root) {
    initReveal(root);
    initCount(root);
    initTabs(root);
    initCompare(root);
    initRails(root);
    initTimelines(root);
    initClocks(root);
    initBars(root);
    initFaq(root);
  }

  initIntro();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initSticky(); initVideos(); });
  } else {
    initAll(); initSticky(); initVideos();
  }

  /* Theme editor: re-init a section when it is added or changed */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); setHeaderH(); });
})();
